import { ApprovalCopyValues } from "./types";

export const APPROVAL_COPY_INITIAL_VALUES: ApprovalCopyValues = {
  approvalId: null,
  newApprovalTypeId: null,
  newName: null,
  newPriorityNumber: null
}